type BrandLogoProps = {
  variant?: 'wordmark' | 'lockup'
  className?: string
  priority?: boolean
}

const sources = {
  wordmark: '/marnixia-wordmark.png',
  lockup: '/marnixia-nixi-lockup.png',
}

export function BrandLogo({ variant = 'wordmark', className = '', priority = false }: BrandLogoProps) {
  const alt = variant === 'lockup' ? 'Marnixia with Nixi' : 'Marnixia'
  return (
    <img
      src={sources[variant]}
      alt={alt}
      className={`block object-contain ${className}`}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
    />
  )
}

